import FilterForm from 'components/forms/FilterForm';
import { CrudFilters } from '@refinedev/core';
import { DatePicker, Form, FormProps, Input, Select } from 'antd';
import { Dayjs } from 'dayjs';
import { toRangeDateFilter } from 'services/date';

// Filtro das abas que listam um aluno por linha com o agregado das tentativas dele
// (avaliação discursiva e atividade). O período recorta as tentativas, e com elas os
// totais da linha; a situação recorta os alunos pela coluna "Status".
export interface IStudentAttemptsFilter {
  search_name?: string;
  search_email?: string;
  correction_status?: CorrectionStatus;
  period?: [Dayjs, Dayjs] | null;
}

type CorrectionStatus = 'awaiting_correction' | 'no_pending';

const CORRECTION_STATUS_OPTIONS: { label: string; value: CorrectionStatus }[] =
  [
    { label: 'Aguardando correção', value: 'awaiting_correction' },
    { label: 'Nenhuma pendência', value: 'no_pending' }
  ];

export const toStudentAttemptsFilters = ({
  search_name,
  search_email,
  correction_status,
  period
}: IStudentAttemptsFilter): CrudFilters => [
  { field: 'filter[search_name]', operator: 'eq', value: search_name },
  { field: 'filter[search_email]', operator: 'eq', value: search_email },
  {
    field: 'filter[correction_status]',
    operator: 'eq',
    value: correction_status
  },
  {
    field: 'filter[by_completed_range_date][]',
    operator: 'eq',
    value: toRangeDateFilter(period)
  }
];

interface StudentAttemptsFilterProps {
  searchFormProps: FormProps<IStudentAttemptsFilter>;
}

export const StudentAttemptsFilter = ({
  searchFormProps
}: StudentAttemptsFilterProps) => (
  <FilterForm searchFormProps={searchFormProps}>
    <Form.Item label="Aluno" name="search_name" className="mb-0">
      <Input placeholder="Nome do aluno" className="w-64" />
    </Form.Item>
    <Form.Item label="E-mail" name="search_email" className="mb-0">
      <Input placeholder="E-mail do aluno" className="w-64" />
    </Form.Item>
    <Form.Item label="Status" name="correction_status" className="mb-0">
      <Select
        allowClear
        placeholder="Todos"
        options={CORRECTION_STATUS_OPTIONS}
        className="w-48"
      />
    </Form.Item>
    <Form.Item label="Finalizada entre" name="period" className="mb-0">
      <DatePicker.RangePicker
        format="DD/MM/YYYY"
        placeholder={['Data inicial', 'Data final']}
      />
    </Form.Item>
  </FilterForm>
);
